<template>
    <main class="page" v-if="getTraining">
        <!-- Banner -->
        <motor-banner  v-if="main" :bgimg="{
            src: env.imageUrl + main.banner.banner_training.image,
            loading: env.imageUrl + main.banner.banner_training.thumb_image,
        }" title="training" :start="true" />
        <div class="motor-container">
            <div class="page-info">
                <h1>{{getTraining.title}}</h1>
                <p v-html="getTraining.header_description"></p>
                <ul>
                    <li v-for="item in getTraining.worktrainingitem" :key="item.id">
                        {{item.name}}
                    </li>
                </ul>
                <p v-html="getTraining.footer_description"></p>
            </div>
            <div class="contact-info">
                <div class="info info--address">
                    <div>
                        <a target="_blank" :href="getTraining.address_url">
                            {{getTraining.address}}
                        </a>
                    </div>
                </div>
                <div class="info info--phone">
                    <div>
                        <a target="_blank" :href="'tel:' + phone" v-for="(phone, index) in getTraining.phones" :key="index">
                            {{phone}}
                        </a>
                    </div>
                </div>
                <div class="info info--email">
                    <div>
                        <a target="_blank" :href="isEmail(email)" v-for="(email, index) in getTraining.email_website" :key="index">
                            {{email}}
                        </a>
                    </div>
                </div>
            </div>
            <!-- Section -->
            <section class="section section--gallery" v-if="getTraining.worktrainingimage.length">
                <div class="secd-container">
                    <div class="image-view">
                        <img v-lazy="env.imageUrl + getTraining.worktrainingimage[index].image" alt="gallery image">
                    </div>
                    <div class="images">
                        <div class="image" 
                            @click="index = i"
                            v-for="(image, i) in getTraining.worktrainingimage" :key="image.id"
                            :class="{'active': index === i}"
                            v-lazy:background-image.container="env.imageUrl + image.thumb_image"></div>
                    </div>
                    <div class="mobile-images">
                        <img class="image" v-lazy="{
                            src: env.imageUrl + image.image,
                            loading: env.imageUrl + image.thumb_image,
                        }" v-for="image in getTraining.worktrainingimage" :key="image.id">
                    </div>
                </div>
            </section>
        </div>
        <!-- Footer -->
        <motor-footer :data="main" />
    </main>
    <main class="page page--loading-with-image" v-else>
        <div class="banner-image"></div>
        <div class="loading">
            <div class="loading--icon"></div>
        </div>
    </main>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import { env } from '../enviorments'

import MotorBanner from '@/components/MotorBanner.vue'
import BannerImg from '@/assets/images/home-banner.jpg'
import img from '../assets/images/home-banner.jpg'

export default {
    name: 'class',
    components: {
        MotorBanner,
    },
    data() {
        return {
            BannerImg,
            index: 0,
            img,
            env,
        }
    },
    computed: {
        ...mapState({
            main: state => state.main,
            training: state => state.training,
        }),
        ...mapGetters([
            'getTraining'
        ])
    },
    methods: {
        ...mapActions({
            callMain: 'callMain',
            callTraining: 'callTraining',
        }),
        isEmail(addr) {
            if (addr.includes('@')) return 'mailto:' + addr
            else if (addr.startsWith('http')) return addr
            else return 'https://' + addr
        }
    },
    async mounted() {
        if (!this.main) await this.callMain()
        if (!this.getTraining) {
            await this.callTraining()
            console.log(this.getTraining)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/showroom.scss';
.page {
    .motor-container {
        max-width: 1000px;
    }
}
</style>
